module.exports = __webpack_public_path__ + "static/img/zhinengzhizao-2.f8069bae.svg";